import { render, staticRenderFns } from "./SectionDivisionEdit.vue?vue&type=template&id=132da46c&scoped=true&"
import script from "./SectionDivisionEdit.vue?vue&type=script&lang=js&"
export * from "./SectionDivisionEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "132da46c",
  null
  
)

export default component.exports